import { computed } from 'vue'
import { useNuxtApp } from '#app'
import {
  normalizeToCamelCase,
  normalizeWithoutSpecialCharacters,
} from '~/utils/stringNormalize'

export interface GenderMenuItem {
  key: string
  label: string
}

/**
 * Composable for managing gender menu items with internationalization support
 *
 * @returns Object containing gender menu items with translated labels
 */
export const useGenderMenuItems = () => {
  const { $i18n } = useNuxtApp()
  const { t } = $i18n

  const genderMenuItems = computed<GenderMenuItem[]>(() => [
    {
      key: t('genders.men').toLowerCase(),
      label: t('genders.men'),
    },
    {
      key: t('genders.women').toLowerCase(),
      label: t('genders.women'),
    },
    {
      key: t('genders.kids').toLowerCase(),
      label: t('genders.kids'),
    },
  ])

  const isValidGender = (key: string) => {
    return genderMenuItems.value.some(
      (item) => formatGender(item.label) === formatGender(key),
    )
  }

  const formatGender = (key: string) => {
    return normalizeWithoutSpecialCharacters(normalizeToCamelCase(key))
  }

  const genderCategoriesMap = computed(() => {
    return genderMenuItems.value.reduce(
      (acc, item) => {
        const gender = normalizeWithoutSpecialCharacters(item.key)
        acc[gender] = `${gender}-${getGenderCategoryId(gender)}`
        return acc
      },
      {} as Record<string, string>,
    )
  })

  const getGenderCategoryId = (gender: string) => {
    const formatedGender =
      normalizeWithoutSpecialCharacters(gender).toLowerCase()

    if (
      formatedGender ===
      normalizeWithoutSpecialCharacters(t('genders.men')).toLowerCase()
    ) {
      return 6
    }
    if (
      formatedGender ===
      normalizeWithoutSpecialCharacters(t('genders.women')).toLowerCase()
    ) {
      return 7
    }
    if (
      formatedGender ===
      normalizeWithoutSpecialCharacters(t('genders.kids')).toLowerCase()
    ) {
      return 8
    }
  }

  return {
    genderMenuItems,
    isValidGender,
    genderCategoriesMap,
    getGenderCategoryId,
  }
}
